import { useEffect, useRef } from "react";

export default function ParticlesCanvas() {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        let raf;

        const resize = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };
        resize();
        window.addEventListener("resize", resize);

        const count = window.innerWidth < 768 ? 35 : 65;
        const particles = [];
        for (let i = 0; i < count; i++) {
            particles.push({
                x: Math.random() * canvas.width,
                y: Math.random() * canvas.height,
                size: Math.random() * 1.8 + 0.6,
                speedX: (Math.random() - 0.5) * 0.25,
                speedY: -Math.random() * 0.25 - 0.05,
                opacity: Math.random() * 0.45 + 0.08,
                phase: Math.random() * Math.PI * 2,
            });
        }

        const draw = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            particles.forEach((p) => {
                p.phase += 0.01;
                const flicker = Math.sin(p.phase) * 0.15 + 0.85;
                ctx.beginPath();
                ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
                ctx.fillStyle = `rgba(255, 240, 200, ${p.opacity * flicker})`;
                ctx.fill();

                p.x += p.speedX;
                p.y += p.speedY;

                if (p.y < -10) {
                    p.y = canvas.height + 10;
                    p.x = Math.random() * canvas.width;
                }
                if (p.x < -10) p.x = canvas.width + 10;
                if (p.x > canvas.width + 10) p.x = -10;
            });
            raf = requestAnimationFrame(draw);
        };
        draw();

        return () => {
            cancelAnimationFrame(raf);
            window.removeEventListener("resize", resize);
        };
    }, []);

    return <canvas ref={canvasRef} data-testid="particle-canvas" className="particle-canvas" />;
}
